import AmityAdapterEditor from './AmityAdapterEditor';
export default AmityAdapterEditor;
export { defaultBlockComponentMap } from './plugins/defaultElementsPlugin';
export { defaultMarkComponentMap } from './plugins/defaultMarkPlugins';
//# sourceMappingURL=index.js.map